import { clientEnvIsAndroid } from "./isAndroid";
import { clientEnvIsDesktop } from "./isDesktop";

export const clientEnvIsAndroidBrowser = (): boolean => {
  return clientEnvIsAndroid() && !clientEnvIsDesktop();
};
